// src/components/CustomCursor.js
import React, { useEffect, useState } from 'react';
import './CustomCursor.css';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [followerPosition, setFollowerPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if we're on mobile or if menu is open
    const checkVisibility = () => {
      const isMobile = window.innerWidth <= 768;
      const isMenuOpen = document.body.classList.contains('menu-open');
      setIsVisible(!isMobile && !isMenuOpen);
    };

    checkVisibility();
    window.addEventListener('resize', checkVisibility);
    
    // Listen for menu state changes
    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (!isVisible) return;

    const updateCursorPosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const updateFollowerPosition = () => {
      setFollowerPosition(prevPos => ({
        x: prevPos.x + (position.x - prevPos.x) * 0.1,
        y: prevPos.y + (position.y - prevPos.y) * 0.1
      }));
    };

    const handleMouseOver = (e) => {
      if (
        e.target.tagName === 'A' ||
        e.target.tagName === 'BUTTON' ||
        e.target.closest('a') ||
        e.target.closest('button')
      ) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    window.addEventListener('mousemove', updateCursorPosition);
    window.addEventListener('mouseover', handleMouseOver);
    
    const animationFrame = setInterval(updateFollowerPosition, 16);

    return () => {
      window.removeEventListener('mousemove', updateCursorPosition);
      window.removeEventListener('mouseover', handleMouseOver);
      clearInterval(animationFrame);
      window.removeEventListener('resize', checkVisibility);
      observer.disconnect();
    };
  }, [position, isVisible]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className="custom-cursor"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
        }}
      />
      <div
        className={`custom-cursor-follower ${isHovering ? 'hovering' : ''}`}
        style={{
          left: `${followerPosition.x}px`,
          top: `${followerPosition.y}px`,
        }}
      />
    </>
  );
};

export default CustomCursor;